import React from 'react';
import styles from './ContentHeader.module.scss';
import { TextLink, Tooltip } from '@moneyforward/ap-frontend-components';

export type ContentHeaderProps = {
  title?: string;
  content?: ContentProps;
};

export type ContentProps = {
  href?: string;
  title?: string;
  textLink?: string;
};

export const ContentHeader: React.FC<ContentHeaderProps> = ({
  title = '支払依頼申請',
  content,
}) => {
  const defaultContent = (
    <>
      <span className={styles.fixedTag}>申請番号</span>
      <TextLink
        href={content?.href}
        target='_blank'
        rel='noopener noreferrer'
        className={!content?.href ? styles.textLink : ''}
      >
        <span className={styles.contentLink}>{content?.textLink}</span>
      </TextLink>
      <span className={styles.tag}>|</span>
      <span className={styles.fixedTag}>申請タイトル</span>
      <Tooltip title={content?.title}>
        <span className={styles.title}>{content?.title}</span>
      </Tooltip>
    </>
  );

  return (
    <div className={styles.root}>
      <div className={styles.sectionTitle}>{title}</div>
      <div className={styles.infoRow}>{defaultContent}</div>
    </div>
  );
};
